import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Usage tab body (SWOOP-224), rendered inside the vehicle-profile layout at
 * `/vehicles/$vehicleId/overview/usage`. Permission gating (`vehicles:list`) is inherited from the
 * layout route's `beforeLoad`.
 */
export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId_/overview/usage')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicle-usage-page')),
  staticData: { titleKey: 'vehicleUsage' },
});
